import clsx from 'clsx';
import styles from './Avatar.module.css';

interface Props {
  src: string | null;
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export const Avatar = ({ src, name, size = 'md', className }: Props) => {
  if (src) {
    return (
      <img
        src={src}
        alt=""
        className={clsx(styles.avatar, styles[`size-${size}`], className)}
      />
    );
  }
  return (
    <div className={clsx(styles.fallback, styles[`size-${size}`], className)}>
      {name.charAt(0).toUpperCase()}
    </div>
  );
};